import React from "react";
import { getPlatformIcon } from "../../utils/platforms";
import { formatCompact } from "./utils";

const TopCreatorCard = ({ item, rank, onClick }) => {
  const creator = item.creator;
  const platformIcon = getPlatformIcon(creator.platform);

  return (
    <div
      className="flex items-center gap-4 p-4 bg-theme-main rounded-xl hover:bg-opacity-80 transition-all cursor-pointer group"
      onClick={onClick}
    >
      <div className="w-8 h-8 rounded-full bg-theme-primary bg-opacity-20 flex items-center justify-center text-sm font-bold text-theme-primary">
        {rank}
      </div>
      <div className="w-12 h-12 rounded-full bg-theme-secondary flex items-center justify-center overflow-hidden flex-shrink-0">
        {creator.profile_image_url ? (
          <img src={creator.profile_image_url} alt="" className="w-full h-full object-cover" />
        ) : platformIcon ? (
          <div className="w-6 h-6">{React.cloneElement(platformIcon, { className: "w-6 h-6" })}</div>
        ) : (
          <span className="text-theme-text opacity-40 text-lg font-semibold">
            {(creator.name || creator.platform_id || '?')[0].toUpperCase()}
          </span>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-theme-text truncate group-hover:text-theme-primary transition-colors">
          {creator.name || creator.platform_id}
        </p>
        <p className="text-xs text-theme-text opacity-50">
          {formatCompact(creator.subscribers || creator.follower_count || 0)} followers
        </p>
      </div>
      <div className="text-right">
        <div className="text-lg font-bold text-theme-text">
          {item.category_fit?.fit_score != null ? item.category_fit.fit_score : "—"}
        </div>
        <div className="text-xs text-theme-text opacity-50">fit score</div>
      </div>
      <svg className="w-5 h-5 text-theme-text opacity-30 group-hover:opacity-70 transition-opacity" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
    </div>
  );
};

export default TopCreatorCard;
